import React, { useEffect } from "react";
import styled from "styled-components";
import HeroSection from "../components/sections/HeroSection";
import AboutSection from "../components/sections/AboutSection";
import ServicesSection from "../components/sections/ServicesSection";
import GallerySection from "../components/sections/GallerySection";
import CtaSection from "../components/sections/CtaSection";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <HomeContainer>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <GallerySection />
      <CtaSection />
    </HomeContainer>
  );
};

const HomeContainer = styled.main`
  min-height: 100vh;
  background-color: var(--dark-bg);
`;

export default Home;

